import { adminApiRequest } from "../../utils/apiUtils";

export interface ICreateMemberClubReward {
  clubId: number;
  userIds: number[];
}

export interface ICreateMemberClubRewardResponse {
  clubId: number;
  userId: number;
}

export const ClubRewardAPI = {
  createMemberClubReward: (body: ICreateMemberClubReward) => {
    return adminApiRequest.post(`/club-reward`, body).then((res) => res.data);
  },
  getMemberClubReward: (clubId: number) => {
    return adminApiRequest
      .get(`/club-reward/list/${clubId}`)
      .then((res) => res.data);
  },
  deleteMemberClubReward: (clubId: number, userId: number) => {
    return adminApiRequest
      .delete(`/club-reward?clubId=${clubId}&userId=${userId}`)
      .then((res) => res.data);
  },
};
